import request from '@/utils/request'

// 获取品项分类映射（内部编码 → 显示名/颜色）
export function getItemCategoryMapping() {
  return request({
    url: '/api/Extend/LqItemCategoryConfig/Actions/GetMapping',
    method: 'get'
  })
}
